module.exports = __webpack_public_path__ + "static/media/21ECLAC39.08456f23.jpg";